import React from 'react';
import { generateBemCss } from 'general/js/helpers';
import { getTodayBemClass } from './score-themes';

const ScoreTodayCell = ({ par, childCss }) => {
    const bemCss = generateBemCss('score-cell', [getTodayBemClass(par), 'has-border']);
    let parText = par;

    if (!parText) {
        parText = '-';
    }

    return <div className={`${childCss} ${bemCss}`}>{parText}</div>;
};

ScoreTodayCell.defaultProps = {
    childCss: '',
};

export default ScoreTodayCell;
